import * as React from 'react';
import Col from 'antd/lib/col';
import Row from 'antd/lib/row';
import {
    Value,
    Values,
} from 'one-ui-values';

import {
    EmploymentInfoCardProps,
} from './props';

import {
    EmploymentInfoModel
} from './model';

import {
    CardLight,
} from 'one-ui-card/src/card-light';
import {
    CardNoData
} from 'one-ui-card';
import {
    checkCardHasError,
    CardErrorMsg,
    CardLockIcon
} from 'one-card-notification';
import { useCtx } from "one-ui-provider";
import {FinessePhonePlugin} from 'one-comp-phone'
/**
 * This function returns the Additional Information
 * @param props component property
 * @returns JSX code Additional Information Card
 */
export const EmploymentInfoCard = <M extends EmploymentInfoModel>(
    props: EmploymentInfoCardProps<M>
) => {
    const {
        model,
        title,
    } = props;
    const {
        subjects,
        selected
    } = model || {};
    const { settings } = useCtx();
    const { uisettings: { dashboardcardconfig } } = settings;
    const employmentdata = selected?.employmentinfo;
    let employeename = "",employeroccupation = "", employercontactnumber = ""
    if(employmentdata?.length > 0) {
        employeename = employmentdata[0]?.employername;
        employeroccupation = employmentdata[0]?.occupation;
        employercontactnumber = employmentdata[0]?.contactnumber
    }
    let emrgencyname = (
        <Values >
            <Value
                label="Employer Name"
                value={employeename}
            />
        </Values>

    )
    let addinfoUI = (
        <>
            <Row gutter={[4, 4]}>
                <Col span={24} >
                    {emrgencyname}
                </Col>
            </Row>
            <Row gutter={[4, 4]}>
                <Col span = {24}>
                    <Values>
                        <Value
                            label="Occupation"
                            value={employeroccupation}
                        />
                    </Values>
                </Col>
            </Row>
            <Row gutter={[4, 4]}>
                <Col span = {24}>
                    <Values>
                    <FinessePhonePlugin 
                          label='Contact Number'
                          phone={employercontactnumber}
                       />
                    </Values>
                </Col>
            </Row>
            
        </>

    );
    // }

    // check for the no details found on api response or employername is empty or null
    if ((subjects?.length === 0 && selected === undefined) || 
    (employmentdata?.length === 0)) {
        addinfoUI = (
            <CardNoData />
        )
    }

    if(checkCardHasError('Subject') && 
      ((subjects?.length === 0 && selected === undefined) || 
      (employmentdata?.length === 0 ))){
        addinfoUI = (<CardErrorMsg />)
    }
    // Based on employmentInformation flag If employmentInformation flag set as false then Lock Icon Will Show
    if (!dashboardcardconfig?.employmentInformation){
        addinfoUI = 
        <>
            <CardLockIcon />
        </>
    }
    return (
        <CardLight
            title={title}
            body={(
                <>
                    {addinfoUI}
                </>
            )}
        />
    );
};
